import { useIntl } from 'react-intl'

import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { getChatTripPlannerNewChatPath } from 'tripPlanner/config'

interface Props {
  searchQuery?: string
}

function HotelSearchTripPlannerBanner({ searchQuery }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'PVW1UinD3sEdbEg6vIBh',
    defaultMessage: 'Keep exploring with AI Trip Planner',
    description: 'Heading on the hotel search banner that invites users to continue exploring offers with AI Trip Planner',
  })
  const description = intl.formatMessage({
    id: 's3MHzyeZWAHS-p8SxRBI',
    defaultMessage: 'Tell us more about what you’re looking for and discover personalised offers that better match your needs.',
    description: 'Supporting copy on the hotel search banner that encourages users to refine their search in AI Trip Planner',
  })
  const tryTripPlannerLabel = intl.formatMessage({
    id: 'DhIVDezTjq_7AwjZ55h6',
    defaultMessage: 'Try Trip Planner',
    description: 'Primary action on the hotel search banner that opens a new tab with Trip Planner running the current search query',
  })
  const tripPlannerHref = getChatTripPlannerNewChatPath(searchQuery)

  return (
    <MessageBanner
      data-testid="hotel-search-trip-planner-banner"
      kind="informational"
      heading={heading}
      primaryActionButtonProps={{
        children: tryTripPlannerLabel,
        to: tripPlannerHref,
        target: '_blank',
        size: 'small',
      }}
    >
      {description}
    </MessageBanner>
  )
}

export default HotelSearchTripPlannerBanner
